import { Button, Header, Image, Modal, Form, Icon, Container, Loader } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import React, { Component, useContext, useState, createRef, useParams, useEffect } from 'react'
import { BrowserRouter, Route, Link } from 'react-router-dom';
import { dbClicks } from '../firebase'
import { dbEmails } from '../firebase'


import { AppState } from '../context';

const ModalBlogLogin = () => {
  const someContext = useContext(AppState);
  const {
    blogLogged,
    setBlogLogged,
    blogpop,
    setBlogpop,
    emails
  } = someContext;
  const [signup, setSignup] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {

    setTimeout(() => {
      setBlogLogged(false);
    }, 5000)

  }, []);





  function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  function writeEmail() {
    // var firstname = document.getElementById('firstname').value;
    var username = document.getElementById('username').value;
    var email = document.getElementById('email').value;
    var pass = document.getElementById('password').value
    if (username.length > 0 && email.length > 0 && pass.length > 0 && validateEmail(email)) {
      const constant = { "email": email, "password": pass }// "firstname":firstname
      const dataToPush = {
        [username]: constant
      }
      dbEmails.child('allemails').update(dataToPush)
      setBlogLogged(true)
      setBlogpop(true)
    }
    else {
      alert("Please enter a valid email address.");
    }
  }

  function removePop() {
    setBlogLogged(true);
    setBlogpop(true);
  }

  return (
    <Container>
      <Modal
        open={!blogLogged}
        closeIcon
        closeOnDimmerClick={true}
        onClose={() => removePop()}>
        <Modal.Header>Sign Up on our blog</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header as="h2" style={{ fontWeight: "normal", fontSize: "13px", marginBottom: "10px" }}>Join us in building a community for senior care</Header>
            {signup ? <Form size="large">
              <Form.Group widths='equal'>
                <Form.Input
                  required
                  id="username"
                  label='Public Username'
                />
                <Form.Input
                  required
                  id="email"
                  label='Email:'
                />
                <Form.Input
                  required
                  id="password"
                  label='Password:'
                  type='password'
                />
              </Form.Group>
              <Button type='submit' color="black" onClick={() => writeEmail()}>Submit</Button>
            </Form> : ""}
          </Modal.Description>
          <Modal.Actions>
            {!signup ? <div><Button color="black" style={{ marginBottom: "10px" }} onClick={() => setSignup(true)}>
              <Icon name='pen square' /> Sign-up with email
              </Button>
            </div> : ""}
          </Modal.Actions>
        </Modal.Content>
      </Modal>
      {console.log(blogLogged, blogpop)}
    </Container >)
}

export default ModalBlogLogin
